<template>
    <div>
        <a-table
            :columns="columns"
            :dataSource="props.data"
            bordered
            size="small"
            :pagination="false"
        />
    </div>
</template>

<script setup>
import {defineProps, h, ref} from 'vue'

const props = defineProps({
    data:  [Object]
})

const columns = [
    {
        title: 'Identificação',
        dataIndex: 'isPromising',
        key: 'isPromising',
        customRender: ({ text }) => {
            return text ? 'Promitente' : 'Proprietário';
        },
    },
    { title: 'Tipo', dataIndex: 'type', key: 'type' },
    { title: 'Ordem', dataIndex: 'order', key: 'order' },
    { title: 'Nome', dataIndex: 'name', key: 'name' },
];


</script>

<style scoped>

</style>
